export default "__VITE_ASSET__B$0timvT__"